<template>
  <div
    class="wrap-content"
    :style="{ width: width, color: color, fontSize: fontSize }"
  >
    <img
      style="width: 20px; margin-right: 5px"
      :src="require('@/assets/images/notice.png')"
      alt=""
    />
    <div :style="{ width: width }" class="marquee-wrap" ref="marquee-wrap">
      <div class="scroll" ref="scroll">
        <p class="marquee">{{ text }}</p>
        <p class="copy" ref="copy"></p>
      </div>
      <p class="getWidth" ref="getWidth">{{ text }}</p>
    </div>
    <div class="dateClass">2023-01-18</div>
  </div>
</template>

<script>
export default {
  name: "marquee",
  props: {
    text: {
      type: String,
      required: true,
    },
    width: {
      type: String,
      default: "100%", //默认值
    },
    color: {
      type: String,
      default: "#333333",
    },
    fontSize: {
      type: String,
      default: "16px",
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  created() {
    let timer = setTimeout(() => {
      this.move();
      clearTimeout(timer);
    }, 1000);
  },
  mounted() {
    // for (let item of this.val) {
    // this.text += item
    // }
  },
  methods: {
    move() {
      let maxWidth = this.$refs["marquee-wrap"].clientWidth;
      let width = this.$refs["getWidth"].scrollWidth;
      if (width <= maxWidth) return;
      let scroll = this.$refs["scroll"];
      let copy = this.$refs["copy"];
      copy.innerText = this.text;
      let distance = 0;
      this.timer = setInterval(() => {
        distance -= 1;
        if (-distance >= width) {
          distance = 16;
        }
        scroll.style.transform = "translateX(" + distance + "px)";
      }, 20);
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
.wrap-content {
  display: flex;
  align-items: center;
}
.marquee-wrap {
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.marquee {
  margin-right: 0.16rem;
}
p {
  word-break: keep-all;
  white-space: nowrap;
  margin: 0;
  padding: 0;
}
.scroll {
  display: flex;
}
.getWidth {
  word-break: keep-all;
  white-space: nowrap;
  position: absolute;
  opacity: 0;
  top: 0;
}
.copy {
  margin-left: 10px;
}
.dateClass {
  white-space: nowrap;
  margin-left: 10px;
}
</style>